var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('inventory-default-value-form',{attrs:{"object_id":_vm.unit_id,"object_type":_vm.OBJECT_TYPE_UNIT,"default-value-object":_vm.defaultValueObject}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }